module.exports = __webpack_public_path__ + "img/gallery.25951ea4.jpg";